<template>
  <div>
    <ModalDailyMain v-if="dailyLoginEnabled" />
  </div>
</template>

<script>
import ModalDailyMain from "@/components/daily-login/modal-daily-main";
export default {
  name: "PipeDailyLogin",
  components: { ModalDailyMain },

  data() {
    return {};
  },

  computed: {
    dailyLoginEnabled() {
      return (
        this.isFeatureVisible("dailylogin") &&
        this.isFeatureUnlocked("dailylogin")
      );
    },
  },
  watch: {},
  mounted() {
    console.log("--------- Pipeline Step Daily ----------");
    if (!this.dailyLoginEnabled) {
      this.$store.commit("popups/setNextPipelineQueueStep");
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
